import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentProjectListRequestPageContext,
  ComponentProjectListRequestPageInitialState,
} from ".";

export const ComponentProjectListRequestPageStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    ComponentProjectListRequestPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentProjectListRequestPageContext.Provider value={context}>
      {children}
    </ComponentProjectListRequestPageContext.Provider>
  );
};
